// Product Configuration System
// Merkezi product ayarları ve default değerler

export interface PlatformConfig {
  name: string;
  icon: string;
  domain?: string;
}

export interface ProductConfig {
  // Platform ayarları
  platforms: Record<string, PlatformConfig>;

  // Default değerler
  defaults: {
    rating: number;
    reviewCount: number;
    currency: string;
    currencySymbol: string;
  };

  // UI ayarları
  ui: {
    showRating: boolean;
    showReviewCount: boolean;
    showPlatformBadge: boolean;
    showDiscount: boolean;
    maxTitleLength: number;
    maxDescriptionLength: number;
  };
}

// Default platform konfigürasyonları
const platforms: Record<string, PlatformConfig> = {
  amazon: {
    name: "Amazon.com",
    icon: "📦",
    domain: "amazon",
  },
  shopify: {
    name: "Shopify.com",
    icon: "🛒",
    domain: "shopify",
  },
  default: {
    name: "Shop",
    icon: "🛍️",
  },
};

// Default değerler
const defaults = {
  rating: 4.5,
  reviewCount: 2890,
  currency: "TRY",
  currencySymbol: "₺",
};

// UI ayarları
const ui = {
  showRating: true,
  showReviewCount: true,
  showPlatformBadge: true,
  showDiscount: true,
  maxTitleLength: 60,
  maxDescriptionLength: 120,
};

// Ana konfigürasyon
export const productConfig: ProductConfig = {
  platforms,
  defaults,
  ui,
};

// Platform detection helper
export const detectPlatform = (url?: string): PlatformConfig => {
  if (!url) return platforms.default;

  const urlLower = url.toLowerCase();

  for (const [key, platform] of Object.entries(platforms)) {
    if (
      key !== "default" &&
      platform.domain &&
      urlLower.includes(platform.domain)
    ) {
      return platform;
    }
  }

  return platforms.default;
};

// Currency mapping helper
export const getCurrencySymbol = (currencyId?: number): string => {
  switch (currencyId) {
    case 1:
      return "₺";
    case 2:
      return "€";
    case 3:
      return "$";
    default:
      return defaults.currencySymbol;
  }
};

// Rating format helper
export const formatRating = (rating?: number): number => {
  return rating || defaults.rating;
};

// Review count format helper
export const formatReviewCount = (count?: number): number => {
  return count || defaults.reviewCount;
};
